import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone } from '@fortawesome/free-solid-svg-icons'
import { faEnvelope } from '@fortawesome/free-solid-svg-icons'
import { faMapPin } from '@fortawesome/free-solid-svg-icons'
import Logo from '../assets/images/home/favicon.ico'

export default class Footer extends Component {
    render() {
        return (
            <>
                <div id="footer" className='lead'>
                    <hr />
                    <br />
                    <h3 className='footer-title'><img src={Logo} alt='Logo' width="80" /> </h3>
                    <ul className="footer-list navbar-nav me-auto mb-2 mb-lg-0">
                        <li>
                            <a className=" footer-link fw-bolder" href="#home">Home</a>
                        </li>
                        <li>
                            <a className=" footer-link fw-bolder" href="#chisiamo">Chi Siamo</a>
                        </li>
                        <li>
                            <a className=" footer-link fw-bolder" href="#realizzazioni">
                                Realizzazioni
                            </a>
                        </li>
                        <li>
                            <a className=" footer-link fw-bolder" href="#proposte_edili">Proposte Edili</a>
                        </li>
                        <li>
                            <a className=" footer-link fw-bolder" href="#contatti" >Contatti</a>
                        </li>
                        <li>
                            <a className=" footer-link fw-bolder" href="./privacy_policy.html" tabIndex="-1" aria-disabled="true" >Privacy Policy</a>
                        </li>
                    </ul>
                </div >
                <div className='copyright'>
                    <div className='footer-lastlink'>
                        <a className="fs-5 text" href="tel:3494158040">
                            <FontAwesomeIcon icon={faPhone} /></a>
                        <a className="fs-5 text content" href="mailto:edilpagotto@virgilio.it">
                            <FontAwesomeIcon icon={faEnvelope} />
                        </a>
                        <a href="https://maps.app.goo.gl/pnKxMXd2pzzwb3WS6" className="fs-5 text"><FontAwesomeIcon icon={faMapPin} /></a>
                    </div>

                    <div>&copy; Copyright 2024. EDILPAGOTTO Srl. Tutti i Diritti Riservati.<p>Powered by Riccardo Petrucci.</p></div>
                </div >
            </>
        )
    }
}
